<template>
	<div class="page">
		<top />
		<div style="width: 100%;height: 55px;"></div>
		<designer />
			<div class="home">
				<div  @click="go('My')">我的主页</div>
				<div><</div>
				<div style="color: #E66617;">下载套餐</div>
			</div>
			<div class="wrapList">
				<div class="wrap-tab" style="position: relative;">
					<div class="wrap-tab-item" :class="activeIndex==1?'active':''" @click="handleSelect(1)">充值套餐</div>
					<div class="wrap-tab-item" :class="activeIndex==2?'active':''" @click="handleSelect(2)">我的套餐</div>
          <div class="notic">{{ down_meal_title }}</div>
				</div>
				<div class="top" style="display: flex;justify-content: space-between;">
					<div class="top-item">
						新款区域套餐
					</div>
				  <div class="top-item">免费下载次数：{{ freedownloads }}</div>
				</div>
				<div class="top">
				  <div class="top-item" v-if="expire_freedownloads>0">即将失效次数：{{expire_freedownloads}}</div>
				  <div class="top-item" v-if="expire_date">最近到期时间：{{expire_date}}</div>
				</div>
				<div>
					<div v-if="activeIndex==1">
						<!-- <div class="name">充值下载套餐</div> -->
						<!-- <div class="text">充值套餐可获取下载次数</div> -->
						<el-table :data="down_meal_list" style="width: 100%">
						  <el-table-column prop="name" label="套餐名称" align="center" width="60">
						  </el-table-column>
						  <el-table-column prop="price" label="充值金额" align="center" width="60">
							  <template slot-scope="scope">
							    {{ scope.row.price }}元
							  </template>
						  </el-table-column>
						  <el-table-column prop="price" label="下载数量" align="center" width="60">
							  <template slot-scope="scope">
								{{ scope.row.down_num }}张
							  </template>
						  </el-table-column>
						  <el-table-column prop="price" label="单张价格" align="center" width="60">
							  <template slot-scope="scope">
								{{ scope.row.avg_price }}元
							  </template>
						  </el-table-column>
						  <el-table-column prop="price" label="有效期" align="center" width="70">
							  <template slot-scope="scope">
								{{ scope.row.maturity_days }}天
							  </template>
						  </el-table-column>
						  <el-table-column prop="price" label="操作" align="center">
							  <template slot-scope="scope">
								<el-button
								  size="mini"
								  type="primary"
								  @click="handle(scope.row)"
								  style="border: none;background: #333;"
								  >购买套餐</el-button
								>
							  </template>
						  </el-table-column>
						</el-table>
					</div>
					<div v-if="activeIndex==2">
						<el-table :data="down_meal_order" style="width: 100%">
						  <el-table-column prop="name" label="套餐名称" align="center">
						  </el-table-column>
						  <el-table-column prop="price" label="套餐金额" align="center">
							  <template slot-scope="scope">
							    {{ scope.row.order_amount }}元
							  </template>
						  </el-table-column>
						  <el-table-column prop="price" label="总下载数量" align="center">
							  <template slot-scope="scope">
								{{ scope.row.all_down_num }}张
							  </template>
						  </el-table-column>
						  <el-table-column prop="price" label="剩余下载数量" align="center">
							  <template slot-scope="scope">
								{{ scope.row.cur_down_num }}张
							  </template>
						  </el-table-column>
						  <el-table-column prop="price" label="购买时间" align="center">
							  <template slot-scope="scope">
								{{ scope.row.add_time }}
							  </template>
						  </el-table-column>
						  <el-table-column prop="price" label="到期时间" align="center">
							  <template slot-scope="scope">
								{{ scope.row.expire_time }}
							  </template>
						  </el-table-column>
						</el-table>
						<div class="page-box">
						  <div class="pages">
						    <el-pagination
						      @current-change="handleCurrentChange"
						      :page-size="order_size"
						      layout="total, prev, pager, next"
						      :total="order_count"
						    >
						    </el-pagination>
						  </div>
						</div>
					</div>
				</div>
        <!-- 新增表单容器 -->
        <div v-if="formHTML" v-html="formHTML" style="display: none;"></div>
			</div>
    <div class="wrapList">
      <div class="wrap-tab">
        <div class="wrap-tab-item" :class="original_activeIndex==1?'active':''" @click="handleOriginalSelect(1)">原创套餐</div>
        <div class="wrap-tab-item" :class="original_activeIndex==2?'active':''" @click="handleOriginalSelect(2)">我的套餐</div>
      </div>
      <div class="top">
        <div class="top-item">免费下载次数：{{ original_freedownloads }}</div>
        <div class="top-item" v-if="original_expire_freedownloads>0">即将失效次数：{{original_expire_freedownloads}}</div>
        <div class="top-item" v-if="original_expire_date">最近到期时间：{{original_expire_date}}</div>
      </div>
      <div>
        <div v-if="original_activeIndex==1">
          <!-- <div class="name">充值下载套餐</div> -->
          <!-- <div class="text">充值套餐可获取下载次数</div> -->
          <el-table :data="original_down_meal_list" style="width: 100%">
            <el-table-column prop="name" label="套餐名称" align="center" width="60">
            </el-table-column>
            <el-table-column prop="price" label="充值金额" align="center" width="60">
              <template slot-scope="scope">
                {{ scope.row.price }}元
              </template>
            </el-table-column>
            <el-table-column prop="price" label="下载数量" align="center" width="60">
              <template slot-scope="scope">
                {{ scope.row.down_num }}张
              </template>
            </el-table-column>
            <el-table-column prop="price" label="单张价格" align="center" width="60">
              <template slot-scope="scope">
                {{ scope.row.avg_price }}元
              </template>
            </el-table-column>
            <el-table-column prop="price" label="有效期" align="center" width="70">
              <template slot-scope="scope">
                {{ scope.row.maturity_days }}天
              </template>
            </el-table-column>
            <el-table-column prop="price" label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                    size="mini"
                    type="primary"
                    @click="handle(scope.row)"
                    style="border: none;background: #333;"
                >购买套餐</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="original_activeIndex==2">
          <el-table :data="original_down_meal_order" style="width: 100%">
            <el-table-column prop="name" label="套餐名称" align="center">
            </el-table-column>
            <el-table-column prop="price" label="套餐金额" align="center">
              <template slot-scope="scope">
                {{ scope.row.order_amount }}元
              </template>
            </el-table-column>
            <el-table-column prop="price" label="总下载数量" align="center">
              <template slot-scope="scope">
                {{ scope.row.all_down_num }}张
              </template>
            </el-table-column>
            <el-table-column prop="price" label="剩余下载数量" align="center">
              <template slot-scope="scope">
                {{ scope.row.cur_down_num }}张
              </template>
            </el-table-column>
            <el-table-column prop="price" label="购买时间" align="center">
              <template slot-scope="scope">
                {{ scope.row.add_time }}
              </template>
            </el-table-column>
            <el-table-column prop="price" label="到期时间" align="center">
              <template slot-scope="scope">
                {{ scope.row.expire_time }}
              </template>
            </el-table-column>
          </el-table>
          <div class="page-box">
            <div class="pages">
              <el-pagination
                  @current-change="handleCurrentChangeOriginal"
                  :page-size="order_size"
                  layout="total, prev, pager, next"
                  :total="original_order_count"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
      <!-- 新增表单容器 -->
      <div v-if="formHTML" v-html="formHTML" style="display: none;"></div>
    </div>
<!--    <div v-for="(item,index) in vipInfo" :key="index">-->
<!--      <div class="orderList">-->
<!--        <div class="orderList-content">-->
<!--          <div class="first">{{ item.type_name }}会员计划</div>-->
<!--          <div class="second">开通年卡即享折扣会员</div>-->
<!--          <div class="third">-->
<!--&lt;!&ndash;            <div>折扣卡</div>&ndash;&gt;-->
<!--            <div>会员费</div>-->
<!--            <div>会员特权/条件</div>-->
<!--          </div>-->
<!--          <div class="fourth">-->
<!--&lt;!&ndash;            <div style="margin-left: 8%;">{{item.discount}}折</div>&ndash;&gt;-->
<!--            <div class="" style="margin-left: 8%;">{{ item.price }}元</div>&lt;!&ndash; class="money" &ndash;&gt;-->
<!--            <div style="width: 120px;">-->
<!--              <div>{{ item.activity }}</div>-->
<!--              <div>余额大于0</div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="fifth" @click="handle_vip(item.level_id)">办理会员</div>-->
<!--        </div>-->
<!--      </div>-->
<!--      &lt;!&ndash; 新增表单容器 &ndash;&gt;-->
<!--      <div v-if="formHTML" v-html="formHTML" style="display: none;"></div>-->
<!--    </div>-->
			<info />
    <el-dialog
        :title="dialogTitle"
        :visible.sync="bounced"
        width="320px"
        :close-on-click-modal="isClose"
        center
        class="custom-pay-dialog"
    >
      <div class="qr-wrapper">
        <vue-qr
            :text="downloadData.url"
            :size="200"
            colorDark="#08243c"
            colorLight="#ffffff"
            :margin="10"
        ></vue-qr>
        <p class="tip-text">请长按二维码识别完成支付</p>
      </div>
    </el-dialog>
			<div style="width: 100%;height: 60px;background-color: #F6F6F6;"></div>
			<foot />
			<el-dialog title="提示" :visible.sync="buyShow" width="80%"style="margin-top: 100px;" center>
				<div class="govip">确定要购买{{cur_info.name}}吗？</div>
        <div class="offline">
<!--          <div>购买方式</div>-->
          <!--  通联支付 -->
          <div @click="choose('tlwechat')">
            <img src="../../assets/wx1.png" alt="" v-if="selectedMethod === 'tlwechat'" />
            <img src="../../assets/wx2.png" alt="" v-else />
          </div>
          <div @click="choose('tlalipay')">
            <img src="../../assets/zfb1.png" alt="" v-if="selectedMethod === 'tlalipay'" />
            <img src="../../assets/zfb2.png" alt="" v-else />
          </div>
          <!--        <div @click="choose('tlunion')">-->
          <!--          <img src="../../assets/ysf1.png" alt="" v-if="selectedMethod === 'tlunion'" />-->
          <!--          <img src="../../assets/ysf2.png" alt="" v-else />-->
          <!--        </div>-->
          <div @click="choose('balance')">
            <img src="../../assets/balance1.png" alt="" v-if="selectedMethod === 'balance'" />
            <img src="../../assets/balance2.png" alt="" v-else />
          </div>
          <!--  end -->
        </div>
				<span slot="footer" class="dialog-footer">
					<el-button type="primary" @click="buy" style="background: #0086D9; border: none; width: 100px">确 定
					</el-button>
					<el-button @click="buyShow = false" style="
					background: #c92323;
					color: #ffffff;
					border: none;
					width: 100px;
				  ">取 消</el-button>
				</span>
			</el-dialog>
    <!-- 原创会员弹框 -->
    <el-dialog title="提示" :visible.sync="originalShow" width="80%"style="margin-top: 100px;" center>
      <div class="govip">确定要办理原创会员吗？</div>
      <div class="offline">
        <!--  通联支付 -->
        <div @click="choose('tlwechat')">
          <img src="../../assets/wx1.png" alt="" v-if="selectedMethod === 'tlwechat'" />
          <img src="../../assets/wx2.png" alt="" v-else />
        </div>
        <div @click="choose('tlalipay')">
          <img src="../../assets/zfb1.png" alt="" v-if="selectedMethod === 'tlalipay'" />
          <img src="../../assets/zfb2.png" alt="" v-else />
        </div>
        <!--        <div @click="choose('tlunion')">-->
        <!--          <img src="../../assets/ysf1.png" alt="" v-if="selectedMethod === 'tlunion'" />-->
        <!--          <img src="../../assets/ysf2.png" alt="" v-else />-->
        <!--        </div>-->
        <div @click="choose('balance')">
          <img src="../../assets/balance1.png" alt="" v-if="selectedMethod === 'balance'" />
          <img src="../../assets/balance2.png" alt="" v-else />
        </div>
        <!--  end -->
      </div>
      <span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="buy_vip" style="background: #09253d; border: none; width: 100px">确 定
				</el-button>
				<el-button @click="originalShow = false" style="
		        background: #c92323;
		        color: #ffffff;
		        border: none;
		        width: 100px;
		      ">取 消</el-button>
			</span>
    </el-dialog>
		</div>
</template>

<script>
	import top from "../../components/common/header.vue";
	import foot from "../../components/common/footer.vue";
	import info from "../../components/common/qrCode.vue";
	import designer from "../../components/common/designer.vue";
  import {
    downMealInfo,
    downMealBuy,
    downMealOrder,
    originalDownMealInfo,
    pay_tonglian, select_pay_method, order_pay_polling, userVipInfo, rechargeCard,
  } from "../../request/api";
  import vueQr from "vue-qr";
	export default {
		components: {
			top,
			foot,
			designer,
			info,
      vueQr,
		},
		data() {
			return {
				down_meal_list:[],
				buyShow:false,
				cur_info:{},
				activeIndex:1,
				down_meal_order:[],
				order_page:1,
				order_size:10,
				order_count:0,
				freedownloads:1,
				expire_freedownloads:0,
				expire_date:'',
        selectedMethod: "",
        dialogTitle: "打开微信扫一扫，向我付款", // 默认标题
        isWeChat: false,
        bounced: false, //充值弹框
        isClose: false,
        downloadData: {
          url: "扫码访问的链接地址",
          icon: "随便一张图片的地址也行",
        },
        orderInfo: {
          unified_id: "",
          unified_number: "",
        },
        formHTML: "", // 新增字段存储表单HTML
        vipInfo: "", //vip 信息
        svipInfo: "", //svip 信息
        userInfo: '', //用户会员信息
        vipShow: false,
        svipShow: false,
        seasonShow: false,
        monthShow: false,
        originalShow: false,
        lackBalance:false,
        type_id: "",
        original_down_meal_list: [],
        original_freedownloads: 1,
        original_expire_freedownloads: 0,
        original_expire_date: '',
        original_activeIndex: "1",
        original_down_meal_order: [],
        original_order_count: 0,
        original_order_page: 1,
        down_meal_title: '',
			};
		},
		created() {
			document.title = '以图绘图印花设计网-下载套餐';
			this.getDownMealInfo(1);
      this.checkWeChatBrowser();
      this.getUserVipInfo();
      this.getOriginalDownMealInfo(1);
		},
		methods: {
      checkWeChatBrowser() {
        const userAgent = navigator.userAgent.toLowerCase();
        this.isWeChat = userAgent.indexOf('micromessenger') > -1;
      },
      //获取用户会员信息
      getUserVipInfo() {
        userVipInfo({}).then((res) => {
          console.log(res);
          // this.vipInfo = res.data.vipInfo
          // this.svipInfo = res.data.svipInfo
          this.userInfo = res.data.user_levels
          this.vipInfo = res.data.vip_levels


        });
      },
			getDownMealInfo(type) {
				downMealInfo({
					type:type
				}).then((res) => {
					this.down_meal_list = res.data.down_meal_list;
					this.freedownloads = res.data.freedownloads;
					this.expire_freedownloads = res.data.expire_freedownloads;
					this.expire_date = res.data.expire_date;
          this.down_meal_title = res.data.down_meal_title.value;
				});
			},

      getOriginalDownMealInfo(type) {
        originalDownMealInfo({
          type: type
        }).then((res) => {
          this.original_down_meal_list = res.data.down_meal_list;
          this.original_freedownloads = res.data.freedownloads;
          this.original_expire_freedownloads = res.data.expire_freedownloads;
          this.original_expire_date = res.data.expire_date;
        });
      },

			getDownMealOrder(type) {
        if (type==1){
          var page = this.order_page;
        }else{
          var page = this.original_order_page;
        }
				downMealOrder({
					page: this.order_page,
					size: this.order_size,
          type: type,
				}).then((res) => {
          if (type==1){
            this.down_meal_order = res.data.data;
            this.order_count = res.data.total;
          }else{
            this.original_down_meal_order = res.data.data;
            this.original_order_count = res.data.total;
          }
				});
			},

			handle(row) {
				this.buyShow = !this.buyShow;
				this.cur_info = row;
			},
      handle_vip(level_id) {
        switch (level_id) {
          case 2:
            this.vipShow = !this.vipShow;
            this.type_id = 1
            break;
          case 3:
            this.svipShow = !this.svipShow;
            this.type_id = 2
            break;
          case 4:
            this.originalShow = !this.originalShow;
            this.type_id = 4
            break;
          case 5:
            this.monthShow = !this.monthShow;
            this.type_id = 5
            break;
          case 6:
            this.seasonShow = !this.seasonShow;
            this.type_id = 6
            break;
        }
      },

      choose(method) {
        if (this.selectedMethod === method) {
          // 再次点击已选中的支付方式可取消选择
          this.selectedMethod = "";
        } else {
          this.selectedMethod = method;
        }
        if (this.selectedMethod === 'tlwechat') {
          this.dialogTitle = '打开微信扫一扫，向我付款';
        } else if (this.selectedMethod === 'tlalipay') {
          this.dialogTitle = '打开支付宝扫一扫，向我付款';
        } else if (this.selectedMethod === 'tlunion') {
          this.dialogTitle = '打开云闪付扫一扫，向我付款';
        } else {
          this.dialogTitle = '扫码支付';
        }
      },

			buy() {
        if (!this.selectedMethod) {
          this.$message.error("请选择支付方式");
          return;
        }
				downMealBuy({
					id: this.cur_info.id,
					pay_id: 0,
          payment: this.selectedMethod
				}).then((res) => {
					if (res.code == 200) {
            if (this.selectedMethod === 'balance') {
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.buyShow = false;
              this.getDownMealInfo(1);
            }else {
              this.orderInfo.unified_id = res.data.order_id;
              this.orderInfo.unified_number = res.data.order_no;
              pay_tonglian({
                unified_number: res.data.order_no,
                transaction_type: 9,
                payment: this.selectedMethod
              }).then((res1) => {
                if (res1.code == 200) {
                  if (typeof res1.data == "string") {
                    // window.location.href = res.data;
                    if (this.isWeChat){
                      this.formHTML = res1.data; // 存储表单HTML
                      this.$nextTick(() => {
                        // 查找表单并提交
                        const form = document.getElementById('tongliansubmit');
                        if (form) form.submit();
                      });
                    }else {
                      this.buyShow = false;
                      this.downloadData.url = res1.data;
                      this.bounced = true;
                      this.getSelect_pay_method();
                    }
                  }
                } else {
                  this.$message.error(res.msg);
                }
              });
            }
					}
					if (res.code == 500) {
						this.$message.error(res.msg)
						this.buyShow = false;
					}
				});
			},
      //支付接口列表
      getSelect_pay_method() {
        select_pay_method({
          unified_id: this.orderInfo.unified_id,
          unified_number: this.orderInfo.unified_number,
          transaction_type: 9,
          pay_mark: "allinpay",
          pay_id: 3,
        })
            .then((res) => {
              console.log(res);
              if (res.code == 200) {
                this.order_pay();
              } else {
                this.$message.error(res.msg);
                this.bounced = false;
              }
            })
            .catch((err) => {
              console.log(err);
            });
      },
      //订单支付轮询
      order_pay() {
        var time = setInterval(() => {
          order_pay_polling({
            unified_id: this.orderInfo.unified_id,
            unified_number: this.orderInfo.unified_number,
            transaction_type: 9,
            pay_mark: "allinpay",
            pay_id: 3,
          }).then((res) => {
            console.log("222", res);
            if (res.code == 200) {
              this.$message({
                message: "支付成功",
                type: "success",
              });

              this.buyShow = false;
              this.bounced = false;
              clearInterval(time);
              this.getDownMealInfo(1);
            }
          });
        }, 2000);
      },

      buy_vip() {
        if (!this.selectedMethod) {
          this.$message.error("请选择支付方式");
          return;
        }

        console.log(this.type_id)
        // return
        rechargeCard({
          type_id: this.type_id,
          pay_id: 0,
          payment: this.selectedMethod
        }).then((res) => {
          console.log(res);
          if (res.code == 200) {
            if (this.selectedMethod === 'balance') {
              this.$message({
                message: res.msg,
                type: "success",
              });

              this.vipShow = false;
              this.svipShow = false;
              this.originalShow = false;
              this.monthShow = false;
              this.seasonShow = false;
              this.getUserVipInfo();
            }else {
              this.orderInfo.unified_id = res.data.moneyid;
              this.orderInfo.unified_number = res.data.order_number;
              pay_tonglian({
                unified_number: this.orderInfo.unified_number,
                transaction_type: 3,
                payment: this.selectedMethod
              }).then((res1) => {
                if (res1.code == 200) {
                  if (typeof res1.data == "string") {
                    // window.location.href = res.data;
                    if (this.isWeChat){
                      this.formHTML = res1.data; // 存储表单HTML
                      this.$nextTick(() => {
                        // 查找表单并提交
                        const form = document.getElementById('tongliansubmit');
                        if (form) form.submit();
                      });
                    }else {
                      this.vipShow = false;
                      this.svipShow = false;
                      this.originalShow = false;
                      this.monthShow = false;
                      this.seasonShow = false;
                      this.downloadData.url = res1.data;
                      this.bounced = true;
                      this.getSelect_pay_method();
                    }
                  }
                } else {
                  this.$message.error(res.msg);
                }
              });
            }
          }

          if (res.code == 500) {
            this.lackBalance = true;
            this.vipShow = false;
            this.svipShow = false;
            this.originalShow = false;
            this.monthShow = false;
            this.seasonShow = false;
          }
        });
      },

      //支付接口列表
      getSelect_pay_method_vip() {
        select_pay_method({
          unified_id: this.orderInfo.unified_id,
          unified_number: this.orderInfo.unified_number,
          transaction_type: 3,
          // pay_mark: "wechat",
          // pay_id: 1,
          pay_mark: "allinpay",
          pay_id: 3,
        }).then((res) => {
          if (res.code == 200) {
            this.order_pay_vip();
          } else {
            this.$message.error(res.msg);
            this.bounced = false;
          }
        });
      },

      //订单支付轮询
      order_pay_vip() {
        var time = setInterval(() => {
          order_pay_polling({
            unified_id: this.orderInfo.unified_id,
            unified_number: this.orderInfo.unified_number,
            transaction_type: 3,
            // pay_mark: "wechat",
            // pay_id: 1,
            pay_mark: "allinpay",
            pay_id: 3,
          }).then((res) => {
            console.log("222", res);
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.vipShow = false;
              this.svipShow = false;
              this.originalShow = false;
              this.monthShow = false;
              this.seasonShow = false;
              this.bounced = false;
              clearInterval(time);
              this.getUserVipInfo();
            }
          });
        }, 2000);
      },

			//分页
			handleCurrentChange(val) {
			  this.order_page = val;
			  this.getDownMealOrder(1);
			},

      handleCurrentChangeOriginal(val) {
        this.original_order_page = val;
        this.getDownMealOrder(2);
      },

			handleSelect(key) {
				this.activeIndex = key;
				if(key==1){
					this.getDownMealInfo(1);
				}else{
					this.order_page = 1;
					// this.getDownMealInfo(2);
					this.getDownMealOrder(1);
				}
			},

      handleOriginalSelect(key) {
        this.original_activeIndex = key;
        if (key == 1) {
          this.getOriginalDownMealInfo(1);
        } else {
          this.original_order_page = 1;
          // this.getDownMealInfo(2);
          this.getDownMealOrder(2);
        }
      },
			go(url) {
				this.$router.push({
					name: url,
				});
			},
		},
	};
</script>

<style lang="less" scoped>
	.page {
		background: #F6F6F6;

		.home {
			padding: 0 20px;
			display: flex;
			align-items: center;
			font-size: 13px;

			div {
				margin-right: 7px;
			}
		}
		.wrapList {
			margin-top: 15px;
			padding: 0 10px;
			.wrap-tab{
				display: flex;
				background: #fff;
				padding: 0 12px;
				border-bottom: solid 1px #e6e6e6;
				.wrap-tab-item{
					padding: 18px 0;
					margin-right: 10px;
				}
				.wrap-tab-item.active{
					color: rgb(230, 102, 23);
					border-bottom: 2px solid rgb(230, 102, 23);
				}
			}
			.top {
			  background: #ffffff;
			  font-size: 15px;
			  padding:0 12px;
			  line-height: 30px;
			}
		}
    .orderList {
      margin-top: 15px;
      padding: 0 10px;

      .orderList-content {
        padding: 18px 0px;
        font-size: 13px;
        background-color: #FFFFFF;
        color: #000000;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: center;

        .first {
          font-size: 14px;
        }

        .first::after {
          content: "";
          width: 86px;
          height: 1px;
          background: linear-gradient(-90deg, #ffffff, #08243c, #ffffff);
          display: block;
          margin-top: 9px;
        }

        .second {
          color: #08243C;
          font-size: 12px;
          margin-top: 9px;
        }

        .third {
          font-size: 13px;
          margin-top: 29px;
          width: 85%;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .fourth {
          margin-top: 29px;
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .money {
            position: absolute;
            left: 43%;
            transform: translateX(-43%)
          }
        }

        .fifth {
          border-radius: 2px;
          margin-top: 35px;
          background-color: #08243C;
          color: #FFFFFF;
          width: 150px;
          height: 35px;
          line-height: 35px;
          text-align: center;
        }
      }
    }

    .govip {
      font-size: 13px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #000000;
      text-align: center;
      margin-top: 15px;
    }

	}
  .offline {
    //padding: 12px;
    //font-size: 12px;
    background-color: #ffffff;
    //color: #08243c;
    display: flex;
    padding-top: 12px;
    justify-content: center;

    //div:first-child {
    //  width: 25%;
    //}

    .money {
      margin-left: 18px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;

      .inputMoney {
        display: flex;
        align-items: center;

        input {
          width: 72px;
          height: 28px;
          border: 1px #cdd6de solid;
          text-align: center;
        }
      }

      .fixed {
        width: 75px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        border: 1px #cdd6de solid;
        margin-bottom: 9px;
      }

      .num-active {
        background: #f6f8f9;
      }
    }

    img {
      width: 33px;
      height: 33px;
    }
  }
  .notic {
    font-size: 14px;
    font-weight: 400;
    color: #c92323;
    line-height: 14px;
    /* padding-top: 10px; */
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    right: 0;
    max-width: calc(100% - 170px);
    height: max-content;
  }
</style>
<style lang="less" scoped>
/* 自定义弹框样式 */
.custom-pay-dialog {
  // 标题样式
  .el-dialog__title {
    color: #08243c; // 主题深蓝色
    font-weight: bold;
  }

  // 内容区域
  .qr-wrapper {
    text-align: center;
    padding: 10px 0;

    .tip-text {
      margin-top: 15px;
      color: #666;
      font-size: 12px;
    }
  }

  // 关闭按钮
  .el-dialog__headerbtn {
    top: 12px;
    right: 12px;
    .el-icon-close {
      color: #999;
      &:hover {
        color: #e66617; // 主题橙色
      }
    }
  }
}
</style>
